import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { ReactComponent as LinkedInCircle } from 'images/linkedin-circle.svg';
import { ReactComponent as FacebookCircle } from 'images/facebook-circle.svg';
import { ReactComponent as TwitterCircle } from 'images/twitter-circle.svg';
import { ReactComponent as InstagramCircle } from 'images/instagram-circle.svg';
import { Container } from 'shared-components/Container';
import { SocialMediaURLs } from 'utils/enum';

export const Contacts = () => (
  <Container
    maxWidth={{ xl: '800px' }} mb={4}>
    <Typography
      fontFamily='Montserrat' fontWeight='700' variant='h6' mb={4}>
      Contacts
    </Typography>
    <Typography
      variant='body2' mb={2}>
      If you have questions or feedback about the ADPKD Patient Registry,
      contact us in these ways:
    </Typography>
    <Grid
      container
      mt={1}
      mb={4}
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}>
      <Grid
        item md={6}>
        <Typography
          variant='pb5' color='primary.grey5'>
          Email
        </Typography>
        <Typography
          variant='body2' mt={1}>
          <a
            href='mailto:registry@pkdcure.org'>registry@pkdcure.org</a>
        </Typography>
      </Grid>
      <Grid
        item md={6}>
        <Typography
          variant='pb5' color='primary.grey5'>
          Phone
        </Typography>
        <Typography
          variant='body2' mt={1}>
          <a
            href='tel:8162688478'>816.268.8478</a>
        </Typography>
      </Grid>
    </Grid>
    <Grid
      container
      mt={1}
      mb={4}
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}>
      <Grid
        item md={6}>
        <Typography
          variant='pb5' color='primary.grey5'>
          Regular mail
        </Typography>
        <Typography
          variant='body2' mt={1}>
          PKD Foundation <br />
          c/o The PKDF Research Team <br />
          1001 E 101st Terr, Suite 220 Kansas City, MO 64131
        </Typography>
      </Grid>
      <Grid
        item md={6}>
        <Typography
          variant='pb5' color='primary.grey5'>
          Social media
        </Typography>
        <Box
          mt={1} display='flex' gap={1}>
          <IconButton
            onClick={() =>
              window.open(SocialMediaURLs.Linkedin, '_blank', 'noreferrer')
            }>
            <LinkedInCircle />
          </IconButton>
          <IconButton
            onClick={() =>
              window.open(SocialMediaURLs.Facebook, '_blank', 'noreferrer')
            }>
            <FacebookCircle />
          </IconButton>
          <IconButton
            onClick={() =>
              window.open(SocialMediaURLs.Twitter, '_blank', 'noreferrer')
            }>
            <TwitterCircle />
          </IconButton>
          <IconButton
            onClick={() =>
              window.open(SocialMediaURLs.Instagram, '_blank', 'noreferrer')
            }>
            <InstagramCircle />
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  </Container>
);
